const skillsQuestions = [
  // ─────────────────────────────────
  // 1. COMUNICACIÓN
  // ─────────────────────────────────
  {
    id: 1,
    skill: 'comunicacion',
    question: "Soy bueno explicando cosas complicadas con palabras simples",
    type: 'scale_1_5'
  },
  {
    id: 2,
    skill: 'comunicacion',
    question: "Me siento cómodo hablando en público o frente a cámara",
    type: 'scale_1_5'
  },

  // ─────────────────────────────────
  // 2. CREATIVIDAD
  // ─────────────────────────────────
  {
    id: 3,
    skill: 'creatividad',
    question: "Disfruto inventar cosas nuevas: historias, productos, soluciones",
    type: 'scale_1_5'
  },
  {
    id: 4,
    skill: 'creatividad',
    question: "Cuando veo un problema, encuentro varias formas distintas de resolverlo",
    type: 'scale_1_5'
  },

  // ─────────────────────────────────
  // 3. TECNOLOGÍA
  // ─────────────────────────────────
  {
    id: 5,
    skill: 'tecnologia',
    question: "Me adapto rápido a nuevas apps, programas o plataformas digitales",
    type: 'scale_1_5'
  },
  {
    id: 6,
    skill: 'tecnologia',
    question: "Sé usar herramientas como Excel, Canva, ChatGPT o algo más avanzado",
    type: 'scale_1_5'
  },

  // ─────────────────────────────────
  // 4. ORGANIZACIÓN
  // ─────────────────────────────────
  {
    id: 7,
    skill: 'organizacion',
    question: "Cuando tengo varias tareas, sé priorizarlas y terminarlas a tiempo",
    type: 'scale_1_5'
  },
  {
    id: 8,
    skill: 'organizacion',
    question: "Llevo bien el control de mis pendientes, agenda y compromisos",
    type: 'scale_1_5'
  },

  // ─────────────────────────────────
  // 5. VENTAS
  // ─────────────────────────────────
  {
    id: 9,
    skill: 'ventas',
    question: "Puedo convencer a alguien de comprar algo cuando estoy seguro que le sirve",
    type: 'scale_1_5'
  },
  {
    id: 10,
    skill: 'ventas',
    question: "No me da pena ofrecer mis servicios o productos a desconocidos",
    type: 'scale_1_5'
  },

  // ─────────────────────────────────
  // 6. LIDERAZGO
  // ─────────────────────────────────
  {
    id: 11,
    skill: 'liderazgo',
    question: "La gente me sigue cuando propongo ideas o tomo iniciativa",
    type: 'scale_1_5'
  },
  {
    id: 12,
    skill: 'liderazgo',
    question: "Me siento cómodo tomando decisiones difíciles para un grupo",
    type: 'scale_1_5'
  },

  // ─────────────────────────────────
  // 7. DISEÑO
  // ─────────────────────────────────
  {
    id: 13,
    skill: 'diseno',
    question: "Tengo buen ojo para los colores, tipografías y composición visual",
    type: 'scale_1_5'
  },
  {
    id: 14,
    skill: 'diseno',
    question: "Disfruto crear cosas visuales: posts, presentaciones, decoración, etc.",
    type: 'scale_1_5'
  },

  // ─────────────────────────────────
  // 8. IDIOMAS
  // ─────────────────────────────────
  {
    id: 15,
    skill: 'idiomas',
    question: "Hablo o entiendo inglés a un nivel funcional",
    type: 'scale_1_5'
  },
  {
    id: 16,
    skill: 'idiomas',
    question: "Aprendo idiomas o me adapto a culturas diferentes con facilidad",
    type: 'scale_1_5'
  },

  // ─────────────────────────────────
  // 9. ANÁLISIS / NÚMEROS
  // ─────────────────────────────────
  {
    id: 17,
    skill: 'analisis',
    question: "Disfruto trabajar con números, datos, estadísticas",
    type: 'scale_1_5'
  },
  {
    id: 18,
    skill: 'analisis',
    question: "Tomo decisiones basadas en datos, no solo en intuición",
    type: 'scale_1_5'
  },

  // ─────────────────────────────────
  // 10. EJECUCIÓN / DISCIPLINA
  // ─────────────────────────────────
  {
    id: 19,
    skill: 'ejecucion',
    question: "Cuando me propongo algo, lo termino aunque sea aburrido",
    type: 'scale_1_5'
  },
  {
    id: 20,
    skill: 'ejecucion',
    question: "No procrastino fácilmente, me enfoco hasta cumplir la meta",
    type: 'scale_1_5'
  }
];

export default skillsQuestions;
